import React, { useRef, useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

import './style.css'
import Spacer from '../Spacer'
import Divider from '../Divider'
import { THEMES } from 'src/constatnts'
import { Form } from '../form'
import { Button, Menu, MenuItem } from '@mui/material'

export const ROUTES = {
  home: '/',
  pricing: '/pricing',
  aiPoweredCyberAttackSimulation: '/ai-powered-cyber-attack-simulation',
  securityAwarenessTrainings: '/security-awareness-trainings',
  emailThreatReportButton: '/email-threat-report-button',
  intelligentThreatResponse: '/intelligent-threat-response',
  gamificationPlatform: '/gamification-platform',
  socialEngineeringPrevention: '/social-engineering-prevention',
  behavioralChange: '/behavioral-change',
  comprehensiveCybersecurity: '/comprehensive-cybersecurity',
  proactiveRiskAssessment: '/proactive-risk-assessment',
  globalWorkforceDefense: '/global-workforce-defense',
  appfraud: '/appfraud',
  achieveAndMaintainRobust: '/achieve-and-maintain-robust',
  whyCyberlift: '/why-cyberlift',
  aiPoweredPlatform: '/ai-powered-platform',
  cyberliftVsCompetitors: '/cyberlift-vs-competitors',
  aboutUs: '/about-us',
  terms: '/terms',
  newsroom: '/newsroom',
  partners: '/partners',
  careers: '/careers',
  securityCompliance: '/security-compliance',
  technologies: '/technologies',
  contacts: '/contacts',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-of-use',
  dpa: '/data-processing-agreement'
}

export const NavButton = ({
  fullwidth = false,
  children,
  to = '#',
  variant = 'light',
  size = 'sm',
  style = {},
  onClick = null,
  self = false,
  ref = null,
  color
}) => {
  return (
    <button
      ref={ref}
      className={'row row-center '}
      style={{
        border: variant == 'light' ? `1px solid ${color || '#0075BC'}` : 0,
        background: variant == 'light' ? '#FFFFFF' : `${color || '#0075BC'}`,
        padding: size == 'sm' || size == 'xs' ? '8px 35px' : '22px 35px',
        cursor: 'pointer',
        ...(fullwidth && { width: '100%', justifyContent: 'center' }),
        ...style
      }}
      onClick={() => {
        onClick ? onClick() : window.open(to, self ? '_self' : '_blank').focus()
      }}
    >
      <span
        style={{
          fontFamily: 'Source Sans 3',
          textTransform: 'uppercase',
          letterSpacing: size == 'sm' || size == 'xs' ? 1 : 1.6,
          color: variant == 'light' ? `${color || '#0075BC'}` : '#fff',
          fontSize: size == 'sm' ? 12 : size == 'xs' ? 8 : 16
        }}
      >
        {children}
      </span>
    </button>
  )
}

export const Navigation = ({ theme, style, onOpenDemoModal }) => {
  const [mobileMenuShown, setMobileMenuShown] = useState(false)
  const [mobileFormShown, setMobileFormShown] = useState(false)

  const navigate = useNavigate()

  const handleOpenMenu = () => {
    document.body.classList.toggle('lock-scroll')
    setMobileMenuShown(!mobileMenuShown)
  }

  const handleOpenForm = () => {
    navigate('/activate/registration')
  }

  const btn = useRef(null)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = r => {
    setAnchorEl(r.currentTarget)
  }

  const handleClose = route => {
    if (route) {
      navigate(route)
    }
    setAnchorEl(null)
  }

  return (
    <div style={style} className={'nav row row-center ' + theme}>
      <div className='container1300 row row-center'>
        <div className='row row-center' style={{ width: '100%' }}>
          <NavLink to='/'>
            <img src='/images/logo-ajg.png' className='nav-logo' alt='' />
          </NavLink>

          <Spacer />

          <div className='row row-center hide mob-show'>
            <Button
              sx={{
                background: '#0075BC',
                marginRight: '12px',
                borderRadius: 0,
                padding: '8px 35px',
                letterSpacing: 1,
                cursor: 'pointer',
                fontSize: '8px',
                color: '#fff',
                '&:hover': {
                  background: '#336791'
                }
              }}
              ref={btn}
              onClick={handleClick}
              variant='dark'
              size='md'
            >
              Activate
              <svg width='14' height='13' viewBox='0 0 14 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <g clipPath='url(#clip0_224_20)'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M7.46437 6.69971L5.04688 4.31041L5.79125 3.57471L8.95313 6.69971L5.79125 9.82471L5.04688 9.08901L7.46437 6.69971Z'
                    fill={'#fff'}
                  />
                </g>
                <defs>
                  <clipPath id='clip0_224_20'>
                    <rect width='12.5' height='12.5' fill='white' transform='translate(0.75 0.449707)' />
                  </clipPath>
                </defs>
              </svg>
            </Button>
            <Menu
              sx={{ '& .MuiPaper-root': { width: btn.current?.offsetWidth || '400px', maxWidth: '400px' } }}
              id='basic-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={() => handleClose()}
              slotProps={{
                list: {
                  'aria-labelledby': 'basic-button'
                }
              }}
            >
              <MenuItem onClick={() => handleClose('/activate/uk')}>UK</MenuItem>
              <MenuItem onClick={() => handleClose('/activate/eu')}>EU</MenuItem>
              <MenuItem onClick={() => handleClose('/activate/us')}>US</MenuItem>
              <MenuItem onClick={() => handleClose('/activate/se')}>Sweden</MenuItem>
              <MenuItem onClick={() => handleClose('/activate/ch')}>Switzerland</MenuItem>
              <MenuItem onClick={() => handleClose('/activate/in')}>India</MenuItem>
            </Menu>
          </div>
          <div onClick={handleOpenMenu} className='burger-menu-button'>
            <svg width='19' height='16' viewBox='0 0 19 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M1 1H17.9987'
                stroke={theme == THEMES.light ? '#1D1D29' : '#444444'}
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M1 8.00049H17.9987'
                stroke={theme == THEMES.light ? '#1D1D29' : '#444444'}
                strokeWidth='2'
                strokeLinecap='round'
              />
              <path
                d='M1 15H17.9987'
                stroke={theme == THEMES.light ? '#1D1D29' : '#444444'}
                strokeWidth='2'
                strokeLinecap='round'
              />
            </svg>
          </div>

          <div className='row row-center mob-hide'>
            <NavButton
              style={{ marginRight: 20, background: '#ffffff', border: '1px solid rgb(111 172 222)' }}
              to='https://ukcyberriskmanagement.ajg.com/title'
            >
              Cyber Awareness Check
            </NavButton>
            <NavButton
              style={{ marginRight: 20, background: '#ffffff', border: '1px solid rgb(111 172 222)' }}
              onClick={() => {
                window.open('https://scan.gallaghercdc.com', '_blank')
              }}
            >
              Cyber Defence Scan
            </NavButton>
            <NavButton
              style={{ marginRight: 20, background: '#ffffff', border: '1px solid rgb(111 172 222)' }}
              onClick={() => {
                window.open('https://tprm.cyberresult.com/login', '_blank')
              }}
            >
              Third Party Risk Management
            </NavButton>
            <NavButton variant='dark' to='https://ajgcdc.myconnectsecure.com/sign-in'>
              Sign in
            </NavButton>
          </div>

          {mobileMenuShown && (
            <div className='mobile-menu'>
              <div className='row row-center'>
                <img src='/images/logo-ajg-2.png' width={185} alt='' />
                <Spacer />
                <div onClick={handleOpenMenu} className='burger-menu-button'>
                  <svg width='25' height='26' viewBox='0 0 25 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M6.24219 6.75391L18.7422 19.2539'
                      stroke='#444444'
                      strokeWidth='1.75'
                      strokeLinecap='round'
                    />
                    <path
                      d='M6.24219 19.2461L18.7422 6.7461'
                      stroke='#444444'
                      strokeWidth='1.75'
                      strokeLinecap='round'
                    />
                  </svg>
                </div>
              </div>

              <Divider style={{ margin: '0px 0px 50px 0px', background: '#D8D8FF' }} />
              <NavButton
                fullwidth
                size='md'
                style={{ width: '100%', marginBottom: 28, background: '#ffffff', border: '1px solid rgb(111 172 222)' }}
                onClick={() => {
                  handleOpenMenu()
                  window.open('https://ukcyberriskmanagement.ajg.com/title', '_blank')
                }}
              >
                Cyber Awareness Check
              </NavButton>
              <NavButton
                fullwidth
                size='md'
                style={{ width: '100%', marginBottom: 28, background: '#ffffff', border: '1px solid rgb(111 172 222)' }}
                onClick={() => {
                  handleOpenMenu()
                  window.open('https://scan.gallaghercdc.com', '_blank')
                }}
              >
                Cyber Defence Scan
              </NavButton>
              <NavButton
                fullwidth
                size='md'
                style={{ width: '100%', marginBottom: 28, background: '#ffffff', border: '1px solid rgb(111 172 222)' }}
                onClick={() => {
                  handleOpenMenu()
                  window.open('https://tprm.cyberresult.com/login', '_blank')
                }}
              >
                Third Party Risk Management
              </NavButton>
              <NavButton
                fullwidth
                size='md'
                style={{ width: '100%', marginBottom: 28 }}
                onClick={handleOpenForm}
                variant='dark'
              >
                Book a demo
              </NavButton>
              <NavButton
                fullwidth
                size='md'
                style={{ width: '100%', marginBottom: 28 }}
                onClick={() => {
                  handleOpenMenu()
                  window.open('https://ajgcdc.myconnectsecure.com/sign-in', '_blank')
                }}
              >
                Sign in
              </NavButton>
            </div>
          )}
          {mobileFormShown && (
            <div className='mobile-menu' style={{ padding: '32px 18px' }}>
              <div className='row row-center'>
                <img src='/images/logo-ajg.png' width={140} alt='' />
                <Spacer />
                <div onClick={handleOpenForm} className='burger-menu-button'>
                  <svg width='25' height='26' viewBox='0 0 25 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M6.24219 6.75391L18.7422 19.2539'
                      stroke='#444444'
                      strokeWidth='1.75'
                      strokeLinecap='round'
                    />
                    <path
                      d='M6.24219 19.2461L18.7422 6.7461'
                      stroke='#444444'
                      strokeWidth='1.75'
                      strokeLinecap='round'
                    />
                  </svg>
                </div>
              </div>
              <div className='column' style={{ height: 'calc(100dvh - 130px)', overflow: 'auto' }}>
                <Form onClose={handleOpenForm} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
